import * as ambassadorWixEventsV1TicketDefinition from './events-v1-ticket-definition-ticket-definitions.http.js';
import * as ambassadorWixEventsV1TicketDefinitionTypes from './events-v1-ticket-definition-ticket-definitions.types.js';
import * as ambassadorWixEventsV1TicketDefinitionUniversalTypes from './events-v1-ticket-definition-ticket-definitions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.QueryTicketDefinitionsRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.QueryTicketDefinitionsRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.QueryTicketDefinitionsResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.QueryTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.queryTicketDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/ticket-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTicketDefinitionsV2(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.QueryTicketDefinitionsV2Request,
  ambassadorWixEventsV1TicketDefinitionTypes.QueryTicketDefinitionsV2Request,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.QueryTicketDefinitionsV2Response,
  ambassadorWixEventsV1TicketDefinitionTypes.QueryTicketDefinitionsV2Response
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.queryTicketDefinitionsV2(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/ticket-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listTicketDefinitions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.ListTicketDefinitionsRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.ListTicketDefinitionsRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.ListTicketDefinitionsResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.ListTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.listTicketDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/ticket-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTicketDefinition(): __PublicMethodMetaInfo<
  'GET',
  { definitionId: string },
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.GetTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.GetTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.GetTicketDefinitionResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.GetTicketDefinitionResponse
> {
  const payload = { definitionId: ':definitionId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.getTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/ticket-definitions/{definitionId}',
    pathParams: { definitionId: 'definitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createTicketDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.CreateTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.CreateTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.CreateTicketDefinitionResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.CreateTicketDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.createTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/ticket-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTicketDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { definitionId: string },
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.UpdateTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.UpdateTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.UpdateTicketDefinitionResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.UpdateTicketDefinitionResponse
> {
  const payload = { definitionId: ':definitionId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.updateTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/ticket-definitions/{definitionId}',
    pathParams: { definitionId: 'definitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTicketDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.DeleteTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.DeleteTicketDefinitionRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.DeleteTicketDefinitionResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.DeleteTicketDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.deleteTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/ticket-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeCurrency(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.ChangeCurrencyRequest,
  ambassadorWixEventsV1TicketDefinitionTypes.ChangeCurrencyRequest,
  ambassadorWixEventsV1TicketDefinitionUniversalTypes.ChangeCurrencyResponse,
  ambassadorWixEventsV1TicketDefinitionTypes.ChangeCurrencyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketDefinition.changeCurrency(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/ticket-definitions/currency',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TicketDefinition as TicketDefinitionOriginal,
  Money as MoneyOriginal,
  Dashboard as DashboardOriginal,
  WixFeeConfig as WixFeeConfigOriginal,
  FeeType as FeeTypeOriginal,
  FeeTypeWithLiterals as FeeTypeWithLiteralsOriginal,
  TicketSalePeriod as TicketSalePeriodOriginal,
  TicketSaleStatus as TicketSaleStatusOriginal,
  TicketSaleStatusWithLiterals as TicketSaleStatusWithLiteralsOriginal,
  TicketDefinitionStateEnumState as TicketDefinitionStateEnumStateOriginal,
  TicketDefinitionStateEnumStateWithLiterals as TicketDefinitionStateEnumStateWithLiteralsOriginal,
  TicketPricing as TicketPricingOriginal,
  TicketPricingPriceOneOf as TicketPricingPriceOneOfOriginal,
  PricingOptions as PricingOptionsOriginal,
  PricingOption as PricingOptionOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  QueryTicketDefinitionsRequest as QueryTicketDefinitionsRequestOriginal,
  TicketDefinitionFieldset as TicketDefinitionFieldsetOriginal,
  TicketDefinitionFieldsetWithLiterals as TicketDefinitionFieldsetWithLiteralsOriginal,
  QueryTicketDefinitionsResponse as QueryTicketDefinitionsResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  QueryTicketDefinitionsV2Request as QueryTicketDefinitionsV2RequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTicketDefinitionsV2Response as QueryTicketDefinitionsV2ResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  ListTicketDefinitionsRequest as ListTicketDefinitionsRequestOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  GroupBy as GroupByOriginal,
  GroupByWithLiterals as GroupByWithLiteralsOriginal,
  ListTicketDefinitionsResponse as ListTicketDefinitionsResponseOriginal,
  ResponseMetaData as ResponseMetaDataOriginal,
  GetTicketDefinitionRequest as GetTicketDefinitionRequestOriginal,
  GetTicketDefinitionResponse as GetTicketDefinitionResponseOriginal,
  CreateTicketDefinitionRequest as CreateTicketDefinitionRequestOriginal,
  TicketDefinitionData as TicketDefinitionDataOriginal,
  CreateTicketDefinitionResponse as CreateTicketDefinitionResponseOriginal,
  TicketDefinitionCreated as TicketDefinitionCreatedOriginal,
  OriginatedFrom as OriginatedFromOriginal,
  UpdateTicketDefinitionRequest as UpdateTicketDefinitionRequestOriginal,
  UpdateTicketDefinitionResponse as UpdateTicketDefinitionResponseOriginal,
  TicketDefinitionUpdated as TicketDefinitionUpdatedOriginal,
  DeleteTicketDefinitionRequest as DeleteTicketDefinitionRequestOriginal,
  DeleteTicketDefinitionRequestDeleteOneOf as DeleteTicketDefinitionRequestDeleteOneOfOriginal,
  ById as ByIdOriginal,
  DeleteTicketDefinitionResponse as DeleteTicketDefinitionResponseOriginal,
  TicketDefinitionDeleted as TicketDefinitionDeletedOriginal,
  ChangeCurrencyRequest as ChangeCurrencyRequestOriginal,
  ChangeCurrencyResponse as ChangeCurrencyResponseOriginal,
  BulkCopyTicketDefinitionsByEventIdRequest as BulkCopyTicketDefinitionsByEventIdRequestOriginal,
  BulkCopyTicketDefinitionsByEventIdResponse as BulkCopyTicketDefinitionsByEventIdResponseOriginal,
  CopiedTicketDefinition as CopiedTicketDefinitionOriginal,
  PaidTicketDefinitionExistsRequest as PaidTicketDefinitionExistsRequestOriginal,
  PaidTicketDefinitionExistsResponse as PaidTicketDefinitionExistsResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './events-v1-ticket-definition-ticket-definitions.types.js';
